

export const BASE_URL = import.meta.env.VITE_APP_BASE_URL;
export const ROUTER_URL = import.meta.env.VITE_APP_ROUTER_URL;

export const OSS_URL = import.meta.env.VITE_APP_RESOURCES_URL;
export const GUIDE_URL = import.meta.env.VITE_APP_GUIDE_URL;